// @ts-nocheck
/* eslint-disable */
export const labelIcon = {
    data: `<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11.42 3.89301C11.18 3.55301 10.78 3.33301 10.3333 3.33301L2.99996 3.33967C2.26663 3.33967 1.66663 3.93301 1.66663 4.66634V11.333C1.66663 12.0663 2.26663 12.6597 2.99996 12.6597L10.3333 12.6663C10.78 12.6663 11.18 12.4463 11.42 12.1063L14.3333 7.99967L11.42 3.89301ZM10.3333 11.333H2.99996V4.66634H10.3333L12.7 7.99967L10.3333 11.333Z" fill="currentColor"/></svg>`,
    name: 'label' as const
};